__turbopack_context__.v({
  "select-content": "SelectInput-module-scss-module__RB7K5G__select-content",
  "select-content__item": "SelectInput-module-scss-module__RB7K5G__select-content__item",
  "select-trigger": "SelectInput-module-scss-module__RB7K5G__select-trigger",
  "select-trigger__icon": "SelectInput-module-scss-module__RB7K5G__select-trigger__icon",
  "select-trigger__value": "SelectInput-module-scss-module__RB7K5G__select-trigger__value",
});
